import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { updateData } from "../redux/roundtoSlice"
import VerifiedUserWhite from "../assets/images/VerifiedUserWhite.svg";
import editProfileIcon from "../assets/images/editProfileBlue.svg";
import { Tooltip } from "react-tooltip";



function InACtiveJobCode() {

    const state = useSelector(state => state?.roundData)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const editProfile = () => {
return
        dispatch(updateData({ field: 'isEditDetails', value: true }))
        navigate("/JobApplicationProcess", { state: { fromOtherPage: true } })
    
    
      }

    return (
        <>

<Tooltip id="submit-btn">You don’t have permission to Edit Profile from here</Tooltip>
            <div className="status-main1">
                <div className="status-container">
                    <p className="greeting">Dear {state?.userName || 'Applicant'}</p>
                    {state.type == 'InActiveCode' &&
                        <>
                            <p className="desc" >
                                The Application Process For <span style={{ fontWeight: 600 }} >{state?.position}</span>  has been closed / inactivated !
                            </p>
                            <p className="desc" >
                                Please contact company recruiter directly if you have any questions.
                            </p>
                            <p className="desc" >
                                Wishing you allt he very best
                            </p>
                        </>
                    }
                    {
                        state.type === 'ApplicationStarted' &&
                        <>
                            <p className="desc" >
                                The Application Process For <span style={{ fontWeight: 600 }} >{state?.position}</span>  has already started !
                            </p>
                            <p className="desc" >
                                A link has been shared to your email that will allow you accesses yor application.
                            </p>

                        </>
                    }

                    <button className="personality-btn exit-btn"
                        onClick={() => {
                            navigate('/LoginWithCode')
                        }}
                    >
                        Exit <span className="arrow" data-label="exit-icon"></span>
                    </button>

                </div>
                <div className="dsktp-footer">

        <div className="dsktp-footer-right">
          {/* <div className='lang-dsktp'>
                           <img src={languageIcon} className="mobIcon" alt="Select language" />
                           <p>Behavior test Language</p>
                           <div className='langbox-dsktp' onClick={() => setShowLanguagePopup(true)}>
                               <p>English</p>
                               <img src={arrowUp} className="mobIcon" alt="Select language" />
                           </div>
                       </div> */}

          <button
            className="comp-savebtn"
            onClick={editProfile}
            disabled={true}
            style={{ width: "120px", padding: "8px 14px", height: "40px" }}

            data-tooltip-id="edit-btn"
            data-tooltip-place="top-start"
          >
            Edit Profile

            <Tooltip style={{ width: "220px" }} id="edit-btn">You don’t have permission to Edit Profile from here</Tooltip>
          </button>
        </div>
        <div className="dsktp-footer-left">
          <div className="dsktp-footerjob-info">
            <div className="v-u-jobcode">
              <h6 style={{ display: "flex", justifyContent: "end" }}>
              {state.code}
              </h6>
              <p>
                This application Process is Managed by <span>LYWO</span>
              </p>
            </div>
            <div className="v-u-bg">
              <img src={VerifiedUserWhite} className="vu-icon" alt="" />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="mobile-icons-mcq">

        <div className="mobile-icon-txt" onClick={editProfile}>
          <img src={editProfileIcon} className="mobIcon" alt="Edit Profile" />
          <p>Edit Profile</p>
        </div>
      </div> */}
            </div >

        </>
    )

}


export default InACtiveJobCode